import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  text: {
    zIndex: theme.zIndex.drawer + 1,
    color: "red",
    marginLeft: "5px",
    fontSize: "2rem",
  },
}));

function LoadingAlert(props) {
  const classes = useStyles();
  return (
    <div>
      <Backdrop className={classes.backdrop} open>
        <CircularProgress color="inherit" />
        <hr />
        <div className={classes.text}>{props.text}</div>
      </Backdrop>
    </div>
  );
}

export default LoadingAlert;

LoadingAlert.propTypes = {
  text: PropTypes.string,
  // onsubmit: PropTypes.func,
};
LoadingAlert.defaultProps = {
  text: "",
};
